const ChartColorsExpanded = [
    "#B750BE",
    "#41ADFC",
    "#9B95FD",
    "#C89BE0",
    "#70F0AE",
    "#ED589D",
    "#29C384",
    "#DBE9BE",
    "#16D1D2",
    "#DBA7C1",
    "#3CA3CF",
    "#7EDB83",
    "#5CFD88",
    "#E39263",
    "#F0C94E",
    "#EB9562",
    "#CED0A1",
    "#70BFA5",
    "#5596C4",
    "#B8F7D1",
    "#FFCDD2",
    "#EF9A9A",
    "#E57373",
    "#FF8A80",
    "#FF5252",
    "#FCE4EC",
    "#F8BBD0",
    "#F48FB1",
    "#F06292",
    "#EC407A",
    "#E91E63",
    "#D81B60",
    "#C2185B",
    "#AD1457",
    "#880E4F",
    "#FF80AB",
    "#FF4081",
    "#F50057",
    "#C51162",
    "#F3E5F5",
    "#E1BEE7",
    "#CE93D8",
    "#BA68C8",
    "#AB47BC",
    "#9C27B0",
    "#8E24AA",
    "#7B1FA2",
    "#6A1B9A",
    "#EA80FC",
    "#E040FB",
    "#D500F9",
    "#AA00FF",
    "#EDE7F6",
    "#D1C4E9",
    "#B39DDB",
    "#9575CD",
    "#7E57C2",
    "#673AB7",
    "#5E35B1",
    "#512DA8",
    "#4527A0",
    "#B388FF",
    "#7C4DFF",
    "#651FFF",
    "#6200EA",
    "#C5CAE9",
    "#9FA8DA",
    "#7986CB",
    "#5C6BC0",
    "#3F51B5",
    "#3949AB",
    "#303F9F",
    "#283593",
    "#8C9EFF",
    "#536DFE",
    "#3D5AFE",
    "#304FFE",
    "#90CAF9",
    "#64B5F6",
    "#42A5F5",
    "#2196F3",
    "#1E88E5",
    "#1976D2",
    "#1565C0",
    "#0D47A1",
    "#82B1FF",
    "#448AFF",
    "#2979FF",
    "#2962FF",
    "#B3E5FC",
    "#81D4FA",
    "#4FC3F7",
    "#29B6F6",
    "#03A9F4",
    "#039BE5",
    "#0288D1",
    "#0277BD",
    "#01579B",
    "#80D8FF",
    "#40C4FF",
    "#00B0FF",
    "#0091EA",
    "#B2EBF2",
    "#80DEEA",
    "#4DD0E1",
    "#26C6DA",
    "#00BCD4",
    "#00ACC1",
    "#0097A7",
    "#00838F",
    "#006064",
    "#84FFFF",
    "#18FFFF",
    "#00E5FF",
    "#00B8D4",
];

export default ChartColorsExpanded;
